/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import classNames from 'classnames';

import { type CommonProps } from './types';

const RADIUS = 7;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const ARC_FRACTION = 0.25;

type ButtonSpinnerProps = {
  loadingMessage: string;
  size?: 'small' | 'medium' | 'large';
};

export const ButtonSpinner = ({
  loadingMessage,
  size = 'small',
  htmlAttributes,
  ...restProps
}: CommonProps<'div', ButtonSpinnerProps>) => {
  const classes = classNames('ndl-btn-spin', {
    'ndl-large': size === 'large',
    'ndl-medium': size === 'medium',
    'ndl-small': size === 'small',
  });

  return (
    <div className="ndl-btn-spinner-wrapper" {...restProps} {...htmlAttributes}>
      <svg
        className={classes}
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="8"
          cy="8"
          r={RADIUS}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray={`${CIRCUMFERENCE * ARC_FRACTION} ${CIRCUMFERENCE * (1 - ARC_FRACTION)}`}
        />
      </svg>
      <span className="ndl-btn-spinner-text" role="status">
        {loadingMessage}
      </span>
    </div>
  );
};
